import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * 1×1 transparent GIF used as video `poster` on thumbnail <video> elements.
 * Without a poster, Android Chrome renders a stretched native play-overlay before metadata loads.
 * Setting any poster (even transparent) suppresses that overlay across all browsers.
 */
export const VIDEO_BLANK_POSTER =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"

// Функция для преобразования тайм-кодов в кликабельные ссылки
export function makeTimeCodesClickable(html: string, seekFunction: (time: number) => void): string {
  // УЛУЧШЕННОЕ регулярное выражение для поддержки различных форматов:
  // (MM:SS), (HH:MM:SS), (125:30) - трёхзначные минуты, (MM:SS-MM:SS), (HH:MM:SS-HH:MM:SS)
  // Поддерживает обычный дефис (-), en-dash (–) и em-dash (—)
  const timeCodeRegex = /\((?:(\d{1,2}):)?(\d{1,3}):(\d{2})(?:[-–—](?:(\d{1,2}):)?(\d{1,3}):(\d{2}))?\)/g
  
  return html.replace(timeCodeRegex, (match, hours1, minutes1, seconds1, hours2, minutes2, seconds2) => {
    // Парсим первый тайм-код (начало)
    const h1 = parseInt(hours1 || '0')
    const m1 = parseInt(minutes1)
    const s1 = parseInt(seconds1)
    
    // Если минуты больше 59, конвертируем в часы (например, 125 минут = 2:05)
    let totalMinutes1 = m1
    let totalHours1 = h1
    if (totalMinutes1 >= 60) {
      totalHours1 += Math.floor(totalMinutes1 / 60)
      totalMinutes1 = totalMinutes1 % 60
    }
    
    const timeInSeconds = totalHours1 * 3600 + totalMinutes1 * 60 + s1
    const timeId = `time-${timeInSeconds}`
    
    return `<a href="#${timeId}" class="time-code-link text-blue-600 hover:text-blue-800 hover:underline cursor-pointer font-medium" data-time="${timeInSeconds}">${match}</a>`
  })
}
